import React from 'react';

const Title = ({
  text1,
  text2,
  level = 1,
  className = '',
  animate = true,
  showSeparator = true,
  variant = 'default',
}) => {
  const HeadingTag = `h${Math.min(Math.max(level, 1), 6)}`;

  const variants = {
    default: {
      primary: 'text-[#4c0f2e]',
      secondary: 'text-[#b09287]',
      gradient: 'from-[#2a081a] via-[#e0c3b5] to-[#b09287]',
    },
    elegant: {
      primary: 'text-slate-800',
      secondary: 'text-slate-500',
      gradient: 'from-slate-800 via-slate-400 to-slate-300',
    },
    warm: {
      primary: 'text-amber-900',
      secondary: 'text-amber-600',
      gradient: 'from-amber-900 via-amber-500 to-amber-300',
    },
  };

  const currentVariant = variants[variant] || variants.default;

  const sizeClasses = {
    1: 'text-2xl sm:text-4xl lg:text-5xl',
    2: 'text-xl sm:text-3xl lg:text-4xl',
    3: 'text-lg sm:text-2xl lg:text-3xl',
    4: 'text-base sm:text-xl lg:text-2xl',
    5: 'text-sm sm:text-lg lg:text-xl',
    6: 'text-sm sm:text-base lg:text-lg',
  };

  const separatorSizes = {
    1: 'h-[2px] sm:h-[3px] w-12 sm:w-20 lg:w-24',
    2: 'h-[2px] sm:h-[3px] w-10 sm:w-16 lg:w-20',
    3: 'h-[1.5px] sm:h-[2px] w-8 sm:w-14 lg:w-16',
    4: 'h-[1.5px] sm:h-[2px] w-6 sm:w-12 lg:w-14',
    5: 'h-[1px] sm:h-[1.5px] w-6 sm:w-10 lg:w-12',
    6: 'h-[1px] sm:h-[1.5px] w-4 sm:w-8 lg:w-10',
  };

  return (
    <div className={`inline-flex font-cinzel items-center gap-3 sm:gap-4 ${className}`}>
      <HeadingTag
        className={`
          font-semibold leading-tight tracking-wide
          ${sizeClasses[level]} 
          ${currentVariant.primary}
          ${animate ? 'transition-all duration-300 hover:scale-105' : ''}
        `}
      >
        {text1}
        {text2 && (
          <span
            className={`
              ${currentVariant.secondary} 
              ${animate ? 'transition-colors duration-300' : ''}
            `}
          >
            {' '}
            {text2}
          </span>
        )}
      </HeadingTag>

      {showSeparator && (
        <span
          className={`
            ${separatorSizes[level]}
            bg-gradient-to-r ${currentVariant.gradient}
            ${animate ? 'transition-all duration-500 hover:scale-x-110 hover:opacity-80' : ''}
            rounded-full
          `}
          role="separator"
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default Title;
